import {useCallback, useRef, useState} from "react";

import {gtmEventPhoneVerification} from "@pg-mono/google-tag-manager/src/gtm_event_phone_verification";

import {useUserPhoneVerificationContext} from "../context/UserPhoneVerificationContext";
import {clearPhoneVerificationTimerLS} from "../utils/clear_phone_verification_timer_ls";
import {IPhoneVerificationCodeError, useSendPhoneVerificationCode} from "./use_send_phone_verification_code";

/**
 * Sends the SMS verification code on mount and verifies it, keeping the resend cooldown in localStorage.
 * UI-agnostic counterpart of the logic inside `UserPhoneVerificationForm`.
 */
export const usePhoneVerificationCode = () => {
    const {onError, verifyPhone} = useUserPhoneVerificationContext();
    const [error, setError] = useState<IPhoneVerificationCodeError | null>(null);
    const [isVerifying, setIsVerifying] = useState(false);
    const isVerifyingRef = useRef(false);

    const reportError = useCallback(
        (reportedError: IPhoneVerificationCodeError) => {
            setError(reportedError);
            onError?.(reportedError);
        },
        [onError]
    );

    const clearError = useCallback(() => setError(null), []);
    const isBusy = useCallback(() => isVerifyingRef.current, []);
    const {resendCode, timer} = useSendPhoneVerificationCode({isBusy, onError: reportError, onSendStart: clearError});

    // `onVerified` runs inside the busy window so the caller's CTA stays in its loading state through the work it starts.
    const verifyCode = useCallback(
        async (code: string, onVerified: () => void | Promise<void>) => {
            if (isVerifyingRef.current) return;

            isVerifyingRef.current = true;
            setIsVerifying(true);
            setError(null);

            try {
                const response = await verifyPhone(code);

                if (response.error) {
                    reportError(response.error);
                    return;
                }

                gtmEventPhoneVerification("submitted");
                clearPhoneVerificationTimerLS();
                await onVerified();
            } catch {
                reportError({message: "Wystąpił błąd podczas weryfikacji", status: 500});
            } finally {
                isVerifyingRef.current = false;
                setIsVerifying(false);
            }
        },
        [reportError, verifyPhone]
    );

    return {error, isVerifying, resendCode, timer, verifyCode};
};
import {useCallback, useRef, useState} from "react";

import {gtmEventPhoneVerification} from "@pg-mono/google-tag-manager/src/gtm_event_phone_verification";

import {useUserPhoneVerificationContext} from "../context/UserPhoneVerificationContext";
import {clearPhoneVerificationTimerLS} from "../utils/clear_phone_verification_timer_ls";
import {IPhoneVerificationCodeError, useSendPhoneVerificationCode} from "./use_send_phone_verification_code";

/**
 * Sends the SMS verification code on mount and verifies it, keeping the resend cooldown in localStorage.
 * UI-agnostic counterpart of the logic inside `UserPhoneVerificationForm`.
 */
export const usePhoneVerificationCode = () => {
    const {onError, verifyPhone} = useUserPhoneVerificationContext();
    const [error, setError] = useState<IPhoneVerificationCodeError | null>(null);
    const [isVerifying, setIsVerifying] = useState(false);
    const isVerifyingRef = useRef(false);

    const reportError = useCallback(
        (reportedError: IPhoneVerificationCodeError) => {
            setError(reportedError);
            onError?.(reportedError);
        },
        [onError]
    );

    const clearError = useCallback(() => setError(null), []);
    const isBusy = useCallback(() => isVerifyingRef.current, []);
    const {resendCode, timer} = useSendPhoneVerificationCode({isBusy, onError: reportError, onSendStart: clearError});

    // `onVerified` runs inside the busy window so the caller's CTA stays in its loading state through the work it starts.
    const verifyCode = useCallback(
        async (code: string, onVerified: () => void | Promise<void>) => {
            if (isVerifyingRef.current) return;

            isVerifyingRef.current = true;
            setIsVerifying(true);
            setError(null);

            try {
                const response = await verifyPhone(code);

                if (response.error) {
                    reportError(response.error);
                    return;
                }

                gtmEventPhoneVerification("submitted");
                clearPhoneVerificationTimerLS();
                await onVerified();
            } catch {
                reportError({message: "Wystąpił błąd podczas weryfikacji", status: 500});
            } finally {
                isVerifyingRef.current = false;
                setIsVerifying(false);
            }
        },
        [reportError, verifyPhone]
    );

    return {error, isVerifying, resendCode, timer, verifyCode};
};
